module.exports = __webpack_public_path__ + "img/meditation_50--active.e71fb16f.svg";